/**
 * Язык UI в браузере: сначала явный выбор в localStorage, иначе — по системному/браузерному языку.
 */
export const UI_LANG_STORAGE_KEY = 'mad_ui_lang';

export const UI_LANGUAGES = [
  { value: 'ru', label: 'Русский' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
];

const ALLOWED = new Set(UI_LANGUAGES.map((l) => l.value));

/**
 * Подобрать ru / en / es по navigator (порядок: language, затем languages).
 * Неизвестные или пустые локали → 'en'.
 */
export function inferUiLangFromNavigator() {
  if (typeof navigator === 'undefined') return 'en';
  const list = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
  for (const tag of list) {
    const base = String(tag).toLowerCase().split('-')[0];
    if (base === 'es') return 'es';
    if (base === 'en') return 'en';
    if (base === 'ru') return 'ru';
  }
  return 'en';
}

export function getStoredUiLang() {
  if (typeof window === 'undefined') return 'en';
  try {
    const raw = localStorage.getItem(UI_LANG_STORAGE_KEY);
    if (raw && ALLOWED.has(raw)) return raw;
  } catch {
    /* ignore */
  }
  return inferUiLangFromNavigator();
}

export function setUiLang(lang) {
  if (!ALLOWED.has(lang)) return;
  try {
    localStorage.setItem(UI_LANG_STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('mad:uiLang', { detail: lang }));
  }
}

/** Вызвать при старте приложения (до рендера или сразу после загрузки HTML). */
export function applyStoredUiLang() {
  const lang = getStoredUiLang();
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
}
